import {axios} from '@/utils/request'
import Vue from 'vue'

const api = {
  user: '/api/user',
  role: '/api/role',
  service: '/api/service',
  permission: '/api/permission',
  permissionNoPager: '/api/permission/no-pager'
}

export default api

//post
export function postAction(url, parameter) {
  return axios({
    url: url,
    method: 'post',
    data: addShopParams(parameter)
  })
}

//post
export function postAction2(url, parameter) {
  return axios({
    url: url,
    method: 'post',
    params: addShopParams(parameter)
  })
}

//post method= {post | put}
export function httpAction(url, parameter, method) {
  return axios({
    url: url,
    method: method,
    data: addShopParams(parameter)
  })
}

//put
export function putAction(url, parameter) {
  return axios({
    url: url,
    method: 'put',
    data: addShopParams(parameter)
  })
}

//get
export function getAction(url, parameter) {
  return axios({
    url: url,
    method: 'get',
    params: addShopParams(parameter)
  })
}

//async get
export async function getAsyncAction(url, parameter) {
  var a = await axios({
    url: url,
    method: 'get',
    params: addShopParams(parameter)
  });
  return a
}

//deleteAction
export function deleteAction(url, parameter) {
  return axios({
    url: url,
    method: 'delete',
    params: addShopParams(parameter)
  })
}

export function getUserList(parameter) {
  return axios({
    url: api.user,
    method: 'get',
    params: addShopParams(parameter)
  })
}

export function getRoleList(parameter) {
  return axios({
    url: api.role,
    method: 'get',
    params: addShopParams(parameter)
  })
}

export function getServiceList(parameter) {
  return axios({
    url: api.service,
    method: 'get',
    params: addShopParams(parameter)
  })
}

export function getPermissions(parameter) {
  return axios({
    url: api.permissionNoPager,
    method: 'get',
    params: addShopParams(parameter)
  })
}

// id == 0 add     post
// id != 0 update  put
export function saveService(parameter) {
  return axios({
    url: api.service,
    method: parameter.id == 0 ? 'post' : 'put',
    data: addShopParams(parameter)
  })
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url, parameter) {
  return axios({
    url: url,
    params: parameter,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 获取文件访问路径
 * @param avatar
 * @param imgerver
 * @param str
 * @returns {*}
 */
export function getFileAccessHttpUrl(avatar, imgerver, subStr) {
  if (avatar && avatar.indexOf(subStr) != -1) {
    return avatar;
  } else {
    return imgerver + "/" + avatar;
  }
}

function addShopParams(parameter) {
  if (!parameter) {
    parameter = {}
  }
  // var systemId = Vue.ls.get("systemId");
  // if (systemId && !parameter['systemId']) {
  //   parameter['systemId'] = systemId;
  // }
  //
  // var systemType = Vue.ls.get("systemType");
  // if (systemType && !parameter['systemType']) {
  //   parameter['systemType'] = systemType;
  //   //为店铺时自动添加shopId 和  systemId相同
  //   if (systemType == 2) {
  //     if (systemId && !parameter['shopId']) {
  //       parameter['shopId'] = systemId;
  //     }
  //   }
  // }
  return parameter;
}
